//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AppContainer from 'app_components/layouts/app'
import BreadcrumbComponent from 'app_components/commons/breadcrumb';
import BusinessLandingModule from 'app_components/modules/admin/landings/businessLanding';
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../businessLandingScreen.scss'

// @ADD Component types
interface IBusinessLandingScreenLayoutProps {}

const BusinessLandingScreenLayout: React.FC<IBusinessLandingScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <AppContainer>
      <div className=''>
        <BreadcrumbComponent links={['/admin/landings', '#']} texts={[`${t('components.breadcrumb.landings')}`, `${t('components.breadcrumb.teacher_business')}`]} />
        <div className="row">
          <div className="col-6">
            <BusinessLandingModule/>
          </div>
        </div>
      </div>
    </AppContainer>
  )
}

export default BusinessLandingScreenLayout
